import { useId } from "react";
import { Select as MuiSelect, TextField as MuiTextField } from "@mui/material";

// MUI's non-native Select renders a visually hidden input. Giving that input a
// stable name avoids Chrome's nameless-form-field warning without changing the
// visible control or its value.
export function AccessibleSelect({ id, name, ...props }) {
  const generatedId = useId();
  const fieldId = id || generatedId;
  return <MuiSelect {...props} id={fieldId} name={name || fieldId} />;
}

// TextField with `select` creates a <label for="..."> targeting the Select's
// combobox div, which is not a native labelable element. MUI already connects
// the label through aria-labelledby; omit only the invalid HTML `for`.
export function AccessibleSelectTextField({ id, name, InputLabelProps, ...props }) {
  const generatedId = useId();
  const fieldId = id || generatedId;
  return (
    <MuiTextField
      {...props}
      select
      id={fieldId}
      name={name || fieldId}
      InputLabelProps={{ ...InputLabelProps, htmlFor: undefined }}
    />
  );
}
